{
	"page": {
		"title": "Organization Types",
		"intro": "The kind of a responsible organization — NOC, host, federation, media. A type decides which <strong>categories</strong> its organizations can issue and which sub-agencies their registrars pick from.",
		"add": "Add type",
		"count_one": "{{n}} type",
		"count_other": "{{n}} types"
	},
	"filters": {
		"searchPlaceholder": "Search types by code or name"
	},
	"sort": {
		"order": "Display order",
		"codeAsc": "Code A–Z",
		"codeDesc": "Code Z–A"
	},
	"table": {
		"code": "Code",
		"name": "Name",
		"pickerSub": "Sub-agency picker: {{label}}",
		"organizations": "Organizations",
		"organizationsTitle": "Responsible organizations of this type",
		"subAgencies": "Sub-agencies",
		"subAgenciesTitle": "Sub-agencies offered to this type",
		"categories": "Categories",
		"categoriesTitle": "Categories offered to this type",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"order": "Order",
		"created": "Created",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} type",
		"summary_other": "{{from}}–{{to}} of {{total}} types",
		"empty": "No types"
	},
	"empty": {
		"filteredTitle": "No types match this search",
		"filteredDescription": "Try a broader search, or clear it.",
		"noneTitle": "No organization types yet",
		"noneDescription": "Add the kinds of organization that register people — NOC, host, federation.",
		"clearFilters": "Clear search"
	},
	"stats": {
		"total": "Types",
		"matching": "matching the search"
	},
	"form": {
		"addTitle": "Add organization type",
		"addDescription": "Organizations of this type register people. Choose which categories and sub-agencies it offers on those pages.",
		"addSubmit": "Add type",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} record uses this type — a rename shows there immediately.",
		"editInUse_other": "{{count}} records use this type — a rename shows there immediately.",
		"editEmpty": "Nothing uses this type yet.",
		"field": {
			"code": "Code",
			"codeHint": "The stable key — letters, numbers, - and _. Stored in capitals.",
			"name": "Name",
			"nameHint": "As registrars read it — National Olympic Committee.",
			"subAgencyLabel": "Sub-agency picker label",
			"subAgencyLabelHint": "What the sub-agency field is called for this type — National federation, Division.",
			"sortOrder": "Sort order",
			"sortOrderHint": "Lists and pickers order by this.",
			"active": "Active",
			"activeHint": "Inactive types stay on existing records but can't be picked."
		},
		"placeholder": {
			"code": "NOC",
			"name": "National Olympic Committee",
			"subAgencyLabel": "National federation"
		}
	},
	"delete": {
		"title": "Delete organization type",
		"description": "Delete <strong>{{name}}</strong>? This only works while no organization, sub-agency or category uses it.",
		"confirm": "Delete type",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete type",
		"inUse": "This type is still in use. Deactivate it instead."
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add type",
		"updateFailed": "Couldn't update type"
	},
	"errors": {
		"codeTaken": "A type with that code already exists.",
		"nameTaken": "A type with that name already exists.",
		"invalidValue": "Invalid value"
	}
}
